var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Ops! Parece que você entrou em uma página que não existe!")]),_c('router-link',{attrs:{"to":"/"}},[_c('v-btn',[_vm._v(" Voltar para a página principal ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }